import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'qaroni-board-section-loading',
  templateUrl: './board-section-loading.component.html',
  styleUrls: ['./board-section-loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BoardSectionLoadingComponent {}
